import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader, Col, Row, Form, Badge, Button, Alert } from 'reactstrap';
import InputGroup from '../../../components/cms/form/inputGroup';
import SubmitButtons from '../../../components/cms/form/submitButtons';
import dh from '../../../helpers/date.helper';
import fileHelper from '../../../helpers/file.helper';

const twoCols = { xs: 12, md: 6 };

const vacancyNameKey = 'vacancy_name';

const feedbackFileDir = '/uploads/cv';

const Feedback = ({
  t,
  onChange,
  onSubmit,
  errors,
  formData,
  title,
  statusList,
  isSubmitting,
  isSubmittingRedirect,
}) => (
  <div>
    <Card>
      <CardHeader>
        <strong><i className="fa fa-envelope-o pr-2" />{title}</strong>
      </CardHeader>
      <CardBody>
        <Form onSubmit={onSubmit(true)}>
          <Badge color="primary">{t('Created at')}: {dh.getFormattedDate(formData.created_at)}</Badge>
          <br />
          <Badge color="success">{t('Updated at')}: {dh.getFormattedDate(formData.updated_at)}</Badge>
          <br />
          <Badge className="mb-1" color="secondary">{t('From')}: {formData.type}</Badge>
          <br />
          {
            formData.basket &&
            <Alert color="primary">
              {t('Basket')}: {formData.basket}
            </Alert>
          }
          {
            formData[vacancyNameKey] &&
            <Alert color="primary">
              {t('Position')}: {formData[vacancyNameKey]}
            </Alert>
          }
          <Row>
            <Col {...twoCols}>
              <InputGroup
                label={t('Status')}
                name="status"
                type="select"
                onChange={onChange}
                errors={errors}
                value={formData.status}
                options={statusList}
                empty="-"
                icon="fa fa-cog"
              />
            </Col>
            {formData.file && (
              <Col {...twoCols}>
                <div className="position-relative form-group">
                  <label>
                    {t('File')}
                  </label>
                  <div>
                    <Button
                      href={fileHelper.getFilePath(feedbackFileDir, formData.file)}
                      target="_blank"
                      color="success"
                      inline-block
                      download
                    >
                      <i className="fa fa-save mr-2" />
                      {t('Download')}
                    </Button>
                  </div>
                </div>
              </Col>
            )}
          </Row>
          <Row>
            <Col {...twoCols}>
              <InputGroup
                name="name"
                label={t('Name')}
                onChange={onChange}
                errors={errors}
                value={formData.name}
                icon="fa fa-pencil"
                readOnly
              />
            </Col>
            <Col {...twoCols}>
              <InputGroup
                name="email"
                label={t('E-mail')}
                onChange={onChange}
                errors={errors}
                value={formData.email}
                icon="fa fa-at"
                readOnly
              />
            </Col>
          </Row>
          <Row>
            <Col {...twoCols}>
              <InputGroup
                name="company"
                label={t('Company')}
                onChange={onChange}
                errors={errors}
                value={formData.company}
                icon="fa fa-building"
                readOnly
              />
            </Col>
            <Col {...twoCols}>
              <InputGroup
                name="phone"
                label={t('Phone')}
                onChange={onChange}
                errors={errors}
                value={formData.phone}
                icon="fa fa-phone"
                readOnly
              />
            </Col>
          </Row>
          <InputGroup
            name="message"
            label={t('Message')}
            onChange={onChange}
            errors={errors}
            type="textarea"
            value={formData.message}
            icon="fa fa-envelope-open-o"
            readOnly
          />
          <Row>
            <Col md={12}>
              <SubmitButtons
                isSubmitting={isSubmitting}
                onSubmit={onSubmit}
                isSubmittingRedirect={isSubmittingRedirect}
              />
            </Col>
          </Row>
        </Form>
      </CardBody>
    </Card>
  </div>
);

Feedback.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isSubmittingRedirect: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  file: PropTypes.string.isRequired,
};

export default Feedback;



// WEBPACK FOOTER //
// ./src/views/feedbacks/feedback/Feedback.jsx